













































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ColumnToType, deepCopy } from '@/libs/deep-copy-provider'
import { MATERIAL_TYPES } from '@/constants/schema-constants'
import { MaterialFormInputDto } from '@/dtos/commons'

export class ConsultationUpdateFormInputs {
  message!: string
  material?: MaterialFormInputDto | null = null
}

@Component({
  components: {
    SmBadgeRead: () => import('@/components/atoms/SmBadgeRead.vue'),
    SmBtn: () => import('@/components/atoms/SmBtn.vue'),
    SmBtnText: () => import('@/components/atoms/SmBtnText.vue'),

    SmMaterialInput: () => import('@/components/molecules/SmMaterialInput.vue'),
    SmTextarea: () => import('@/components/molecules/SmTextarea.vue'),
  }
})
export default class SmCardConsultationUpdate extends Vue {
  MATERIAL_TYPES = Object.freeze(MATERIAL_TYPES)

  created(): void {
    this.inputs.message = this.originalMessage
    this.inputs.material = deepCopy(
      this.originalMaterial,
      { material: new ColumnToType(MaterialFormInputDto) },
      'material'
    )
  }

  inputs = new ConsultationUpdateFormInputs()

  @Prop({ default: false })
  private isUnread!: boolean

  @Prop({ default: '' })
  private readonly originalMessage!: string

  @Prop()
  private readonly originalMaterial?: MaterialFormInputDto

  @Prop()
  private readonly fieldIdPrefix?: string

  onClickUpdateBtn(): void {
    this.$emit('update', this.inputs)
  }
}
